import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../assets/Icons";
import OwnerDetailsPage from "../../../containers/Accounts/OwnerAccount/OwnerDetailsPage";

function OwnerAccountDetailsPopUp({
  closeBeneAccountDetailModal,
  Remibursement_owneraccount_id,
  type,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle="Owner account detail"
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        smallPopupHeader={"Are you sure you want to leave this page?"}
        headertextSize="font-md"
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeBeneAccountDetailModal();
          navigate(
            `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${Remibursement_owneraccount_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeBeneAccountDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={false}
      >
        <OwnerDetailsPage
          Remibursement_owneraccount_id={Remibursement_owneraccount_id}
          closeBeneAccountDetailModal={closeBeneAccountDetailModal}
          popType={type}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default OwnerAccountDetailsPopUp;
